import { z } from 'zod';
import { USER_GROUPS } from './group.js';
/** Activity categories are managed by the administrator (Kategoritë screen). */
const hexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Zgjidhni një ngjyrë.');
const name = z.string().trim().min(2, 'Emri duhet të ketë të paktën 2 shkronja.').max(100);
/** Groups the category is offered to; empty = everyone. */
const groups = z.array(z.enum(USER_GROUPS)).max(USER_GROUPS.length);
export const categoryCreateSchema = z.object({ name, color: hexColor, groups: groups.default([]) });
export const categoryUpdateSchema = z.object({
    name: name.optional(),
    color: hexColor.optional(),
    groups: groups.optional(),
    sortOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
});
/**
 * Distinguishable preset colours offered when creating a category (identity colours,
 * shown as dots next to the name — never as text colour).
 */
export const CATEGORY_COLOR_PRESETS = [
    '#1565C0',
    '#2E7D32',
    '#EF6C00',
    '#6A1B9A',
    '#C62828',
    '#00838F',
    '#4E342E',
    '#546E7A',
    '#AD1457',
    '#9E9D24',
    '#283593',
    '#00695C',
];
//# sourceMappingURL=category.js.map